import React from 'react'
import { useTranslation } from 'react-i18next'
import { Table, TableBody, TableHead, Typography } from '@material-ui/core'
import { SidebarAccordionTableRow } from '../common/SidebarAccordionTableRow'

export type CoefficientsByEnergyType = {
  energyType: string
  coefficients: CoefficientsByYear[]
}

type CoefficientsByYear = {
  year: number
  value: number
}

type Props = {
  coefficientsByEnergyType: CoefficientsByEnergyType
  printPadding?: boolean
}

export default function CoefficientsSidebarTable({
  coefficientsByEnergyType,
  printPadding,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  const rows = coefficientsByEnergyType.coefficients.map((coefficient) => ({
    name: String(coefficient.year),
    value: coefficient.value,
  }))

  return (
    <Table>
      <TableHead>
        <SidebarAccordionTableRow
          name={
            <Typography variant="subtitle1">
              {t(`purchasedEnergyType.${coefficientsByEnergyType.energyType}`)}
            </Typography>
          }
          value={<div />}
          showBorder
          printPadding={printPadding}
        />
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <SidebarAccordionTableRow
            key={row.name}
            name={row.name}
            value={row.value}
            printPadding={printPadding}
          />
        ))}
      </TableBody>
    </Table>
  )
}
